module.exports = __webpack_public_path__ + "static/sbb-beeldmerk-94ab12e6b21a8c4485cc7757ba3b17e8.png";